import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_ayoh_hot_giardinayo_mayo_6_pack: FaireProductEntity = {
  token: "p_live_ayoh_hot_giardinayo_mayo_6_pack",
  type: "product",
  name: "Hot Giardinayo Mayo (6-pack)",
  brandToken: "b_live_ayoh_foods",
  brandName: "AYOH Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/f3ff9dae306ed7e660c9a2fcbccfc8c1aebd7c3f68f6b48591bbdb7d70bb6782.jpeg?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
  priceDollars: 25.99,
  msrpDollars: 51.84,
  description: "AYOH hot giardinayo mayo in a 6-pack format.",
  categoryTokens: ["cat_food-drink"],
  tags: ["live-shopping", "bestseller", "condiments"],
  isBestseller: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
